// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3hCjk","filesListContainer":"PosDisputesFiles_filesListContainer__15S2V","filesButton":"PosDisputesFiles_filesButton__DnQm1"};